//@ts-expect-error
export default window.editorModel;
